import React, { useState, useEffect } from 'react';
import { Terminal } from 'lucide-react';

const TerminalAnimation = () => {
  const [currentCommandIndex, setCurrentCommandIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  // Lista di comandi realistici IT/Data/Web
  const commands = [
    'solve_problem()',
    'npm start',
    'python analyze_data.py',
    'SELECT * FROM insights',
    'git push origin main',
    'docker compose up -d',
    'yarn build --production',
    'psql -d healthcare_db',
    'airflow dags trigger',
    'powerbi-cli dashboard',
    'react-app deploy',
    'python etl_pipeline.py',
    'npm run dev',
    'git commit -m "feat: new solution"'
  ];

  useEffect(() => {
    const currentCommand = commands[currentCommandIndex];
    const typingSpeed = isDeleting ? 30 : 80;
    const pauseBeforeDelete = 2000;
    const pauseBeforeNext = 500;

    const timer = setTimeout(() => {
      if (!isDeleting) {
        // Typing
        if (displayedText.length < currentCommand.length) {
          setDisplayedText(currentCommand.slice(0, displayedText.length + 1));
        } else {
          // Pause before deleting
          setTimeout(() => setIsDeleting(true), pauseBeforeDelete);
        }
      } else {
        // Deleting
        if (displayedText.length > 0) {
          setDisplayedText(displayedText.slice(0, -1));
        } else {
          // Move to next command
          setIsDeleting(false);
          setCurrentCommandIndex((prev) => (prev + 1) % commands.length);
        }
      }
    }, isDeleting ? typingSpeed : displayedText.length === currentCommand.length ? pauseBeforeDelete : typingSpeed);

    return () => clearTimeout(timer);
  }, [displayedText, isDeleting, currentCommandIndex, commands]);

  return (
    <div className="mt-4 w-full min-w-0 bg-background border border-foreground p-3 lg:mt-0 lg:absolute lg:-bottom-16 lg:right-0 lg:min-w-[240px]">
      <div className="flex items-center gap-2 text-xs font-mono min-h-[20px] overflow-hidden">
        <Terminal className="w-3.5 h-3.5 text-foreground flex-shrink-0" />
        <span className="text-muted-foreground">$</span>
        <span className="text-foreground truncate">{displayedText}</span>
        <span className="text-foreground animate-pulse">_</span>
      </div>
    </div>
  );
};

export default TerminalAnimation;
